import type { Work } from "@/types";

export const works: Work[] = [
  {
    id: "1",
    title: "长夜将明",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=stylized%20cinematic%20crime%20film%20poster%20artwork%2C%20lone%20silhouette%20under%20streetlamp%20in%20rainy%20night%20alley%2C%20deep%20indigo%20and%20amber%20tones%2C%20dramatic%20moody%20lighting%2C%20painterly%20textured%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-01&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "北京",
    genre: "剧情 / 犯罪",
    tags: ["悬疑", "犯罪", "剧情"],
    director: "陈默",
    cast: ["张译川", "周晓", "林继东"],
    rating: 8.7,
    popularity: 98,
    summary: "一座城市的漫长冬夜，一桩悬而未决的旧案，两位警察用十年时间等待黎明。",
    synopsis:
      "刑警陆行舟接手一桩尘封十年的连环案件，案件背后牵连着整座城市的隐秘往事。当旧证据重新浮出水面，他必须在真相与代价之间做出抉择。影片以冷峻的镜头语言描摹城市夜景，在悬疑的外壳下探讨正义、救赎与坚持的意义。",
    releaseDate: "2024-01-18",
  },
  {
    id: "2",
    title: "山海拾光",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20nostalgic%20family%20drama%20film%20poster%20artwork%2C%20grandmother%20and%20child%20on%20terraced%20hillside%20village%20at%20golden%20sunset%2C%20soft%20orange%20and%20green%20tones%2C%20painterly%20textured%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-02&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "云南",
    genre: "剧情 / 家庭",
    tags: ["家庭", "治愈", "剧情"],
    director: "苏文",
    cast: ["李知秋", "王砚", "陈广生"],
    rating: 8.2,
    popularity: 87,
    summary: "一个在城市迷失的年轻人回到山村，用镜头记录下祖母最后的时光。",
    synopsis:
      "摄影师顾南在城市里失去了创作的动力，回到久别的山村照顾年迈的祖母。在群山与梯田之间，他重新拾起相机，记录下村庄四季与祖母的日常。影片以温柔细腻的笔触讲述亲情与回归，探讨都市人内心深处的乡愁。",
    releaseDate: "2023-09-30",
  },
  {
    id: "3",
    title: "雾中列车",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=stylized%20suspense%20thriller%20film%20poster%20artwork%2C%20old%20train%20crossing%20a%20dense%20mountain%20fog%2C%20cold%20teal%20and%20grey%20palette%20with%20a%20single%20red%20signal%20light%2C%20misty%20atmospheric%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-03&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "重庆",
    genre: "悬疑 / 惊悚",
    tags: ["悬疑", "惊悚", "犯罪"],
    director: "高远",
    cast: ["沈亦白", "周晓", "郑立川"],
    rating: 8.9,
    popularity: 95,
    summary: "一列驶入浓雾的夜行列车，七名乘客，一场无法回头的推理。",
    synopsis:
      "深夜列车驶入山区浓雾后意外停车，车上七名互不相识的乘客发现自己被卷入一场精心设计的谜局。随着线索层层揭开，每个人的秘密逐一暴露。影片以密闭空间与冷色调影像营造强烈压迫感，是近年国产悬疑的代表之作。",
    releaseDate: "2024-06-14",
  },
  {
    id: "4",
    title: "归来仍是少年",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=bright%20youth%20sports%20inspirational%20film%20poster%20artwork%2C%20teenagers%20running%20on%20a%20school%20track%20at%20sunrise%2C%20vivid%20sky%20blue%20and%20warm%20yellow%20tones%2C%20energetic%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-04&orientation=portrait",
    year: 2022,
    decade: "2020年代",
    region: "上海",
    genre: "青春 / 励志",
    tags: ["青春", "励志", "运动"],
    director: "何静",
    cast: ["林书航", "苏念", "何一鸣"],
    rating: 7.9,
    popularity: 78,
    summary: "一群被解散的校田径队少年，用一场长跑重新证明自己。",
    synopsis:
      "因成绩下滑被解散的高中田径队，在退役教练的带领下重新集结。面对质疑与伤病，少年们在跑道上找回了对速度与梦想的热爱。影片用明快的节奏与鲜活的群像，讲述青春里那股不服输的劲头。",
    releaseDate: "2022-08-05",
  },
  {
    id: "5",
    title: "大漠孤烟",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20western%20action%20film%20poster%20artwork%2C%20lone%20horseman%20riding%20across%20vast%20golden%20desert%20dunes%20at%20dusk%2C%20amber%20ochre%20and%20crimson%20sky%2C%20dusty%20painterly%20textured%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-05&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "甘肃",
    genre: "动作 / 西部",
    tags: ["动作", "西部", "冒险"],
    director: "赵北",
    cast: ["秦朗", "白景行", "顾清和"],
    rating: 8.0,
    popularity: 82,
    summary: "一名退役镖师穿越千里戈壁，只为护送一件改变命运的货物。",
    synopsis:
      "清末民初的西北商道上，退役镖师陈万里受雇护送一只神秘木箱穿越戈壁。一路上沙匪、官军与旧日仇家接连而至，他却在旅途中逐渐发现箱中之物与自己身世息息相关。影片用苍茫大漠与硬朗动作呈现一段荡气回肠的旅程。",
    releaseDate: "2023-11-10",
  },
  {
    id: "6",
    title: "城市之光",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=modern%20urban%20romance%20film%20poster%20artwork%2C%20two%20figures%20on%20a%20rooftop%20overlooking%20a%20glowing%20city%20skyline%20at%20night%2C%20deep%20blue%20and%20warm%20neon%20orange%20tones%2C%20dreamy%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-06&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "深圳",
    genre: "都市 / 爱情",
    tags: ["都市", "爱情", "剧情"],
    director: "沈澜",
    cast: ["许安然", "陆则言", "周桐"],
    rating: 7.6,
    popularity: 74,
    summary: "两个在城市里奔波的年轻人，在无数个夜晚里点亮彼此的光。",
    synopsis:
      "设计师程晚与外卖骑手林野在城市的不同角落擦肩而过，又因一场意外相识。他们都在为自己的梦想努力，也在快节奏的都市里寻找归属。影片以温暖明亮的影像记录普通人的坚持与相遇，写下一段关于城市与爱的故事。",
    releaseDate: "2024-05-20",
  },
  {
    id: "7",
    title: "归途",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=emotional%20road%20trip%20drama%20film%20poster%20artwork%2C%20old%20car%20on%20a%20winding%20mountain%20highway%20through%20autumn%20forest%2C%20muted%20green%20amber%20and%20rust%20tones%2C%20melancholic%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-07&orientation=portrait",
    year: 2021,
    decade: "2020年代",
    region: "四川",
    genre: "剧情 / 公路",
    tags: ["公路", "剧情", "亲情"],
    director: "陈默",
    cast: ["王砚", "李知秋", "陈广生"],
    rating: 8.4,
    popularity: 80,
    summary: "一位父亲与多年未见的女儿，开着旧车踏上一条回家的路。",
    synopsis:
      "老周被诊断出重病后，决定开车带着疏远多年的女儿回一趟老家。一路上两人从沉默、争吵到逐渐理解，车窗外的风景也在悄然变化。影片用一条公路串起两代人的隔阂与和解，朴实动人。",
    releaseDate: "2021-10-01",
  },
  {
    id: "8",
    title: "无声告白",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=quiet%20family%20drama%20film%20poster%20artwork%2C%20mother%20and%20deaf%20daughter%20communicating%20with%20hands%20in%20a%20sunlit%20kitchen%2C%20soft%20cream%20and%20sage%20green%20tones%2C%20gentle%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-08&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "杭州",
    genre: "家庭 / 剧情",
    tags: ["家庭", "剧情", "温情"],
    director: "苏文",
    cast: ["何一鸣", "苏念", "李知秋"],
    rating: 8.1,
    popularity: 76,
    summary: "一位听障母亲，用一生无声的方式守护女儿成长。",
    synopsis:
      "听障母亲吴秀莲独自抚养女儿长大，母女之间用彼此才懂的方式交流。当女儿考上外地大学，两人不得不在沉默中学会告别与成长。影片细腻刻画特殊家庭中的爱与坚韧，情感克制而深沉。",
    releaseDate: "2023-04-07",
  },
  {
    id: "9",
    title: "深蓝之下",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=stylized%20sci-fi%20mystery%20film%20poster%20artwork%2C%20diver%20descending%20into%20a%20glowing%20deep%20ocean%20trench%20with%20strange%20lights%2C%20deep%20blue%20cyan%20and%20bio-luminescent%20teal%20tones%2C%20cold%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=mv-09&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "青岛",
    genre: "科幻 / 悬疑",
    tags: ["科幻", "悬疑", "冒险"],
    director: "高远",
    cast: ["沈亦白", "顾清和", "陆则言"],
    rating: 8.6,
    popularity: 91,
    summary: "深海科考队在一次下潜中，发现了不该存在的东西。",
    synopsis:
      "海洋科考队在马里亚纳海沟深处发现一处异常信号源。随着下潜不断深入，队长周野逐渐意识到，他们面对的可能不是自然现象。影片以克制的科幻设定与幽深海景，营造出一种令人窒息的未知恐惧。",
    releaseDate: "2024-07-26",
  },
  {
    id: "10",
    title: "山河故梦",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=grand%20historical%20period%20drama%20poster%20artwork%2C%20warrior%20in%20flowing%20ancient%20robes%20standing%20before%20misty%20mountains%20and%20ancient%20palace%2C%20deep%20jade%20ink%20and%20gold%20tones%2C%20elegant%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=tv-01&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "横店",
    genre: "古装 / 历史",
    tags: ["古装", "历史", "权谋"],
    director: "顾长风",
    cast: ["白景行", "苏念", "秦朗"],
    rating: 8.8,
    popularity: 97,
    summary: "乱世之中，一位少年将军在山河破碎间追寻家国大义。",
    synopsis:
      "少年将军沈砚出身寒门，凭一身武艺踏入朝堂。他卷入党争与边患的漩涡，在忠义与权谋之间艰难抉择。剧集以恢弘的战争场面与细腻的人物刻画，描绘一幅动荡时代的山河长卷。",
    releaseDate: "2024-03-15",
  },
  {
    id: "11",
    title: "都市浮生记",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=modern%20workplace%20drama%20poster%20artwork%2C%20young%20professionals%20walking%20through%20a%20glass%20tower%20lobby%20at%20dusk%2C%20cool%20grey%20and%20amber%20office%20tones%2C%20clean%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=tv-02&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "上海",
    genre: "都市 / 职场",
    tags: ["都市", "职场", "剧情"],
    director: "韩梅",
    cast: ["许安然", "周桐", "陆则言"],
    rating: 8.0,
    popularity: 85,
    summary: "八个都市打工人，在写字楼里上演一出真实又荒诞的浮生群像。",
    synopsis:
      "剧集以一家互联网公司的裁员风波为起点，讲述八位职场人在时代变化中的选择与挣扎。有人被迫转行，有人选择坚守，也有人重新出发。故事贴近现实，用群像视角描摹当代都市人的生存状态。",
    releaseDate: "2023-09-08",
  },
  {
    id: "12",
    title: "风起南城",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%201990s%20era%20drama%20poster%20artwork%2C%20old%20southern%20city%20alley%20with%20bicycles%20and%20lanterns%20at%20dusk%2C%20warm%20sepia%20teal%20and%20rust%20tones%2C%20textured%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=tv-03&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "广州",
    genre: "年代 / 剧情",
    tags: ["年代", "剧情", "家庭"],
    director: "郑立",
    cast: ["何一鸣", "李知秋", "郑立川"],
    rating: 8.5,
    popularity: 89,
    summary: "上世纪九十年代的南方小城，三个家庭在时代浪潮中沉浮。",
    synopsis:
      "故事发生在九十年代南方的一座老城，三个相邻的家庭在改革开放的浪潮里各自经历悲欢。有人下海经商，有人守着老手艺，孩子们在巷子里长大。剧集用充满质感的年代细节，讲述普通人与时代共同成长的故事。",
    releaseDate: "2024-02-02",
  },
  {
    id: "13",
    title: "半城烟雨",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20republican%20era%20drama%20poster%20artwork%2C%20elegant%20woman%20in%20qipao%20under%20an%20oil-paper%20umbrella%20in%20rainy%20old%20town%2C%20muted%20plum%20teal%20and%20soft%20gold%20tones%2C%20delicate%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=tv-04&orientation=portrait",
    year: 2022,
    decade: "2020年代",
    region: "苏州",
    genre: "民国 / 爱情",
    tags: ["民国", "爱情", "年代"],
    director: "顾长风",
    cast: ["苏念", "许安然", "顾清和"],
    rating: 7.8,
    popularity: 72,
    summary: "烟雨江南，一段跨越门第与战火的乱世情缘。",
    synopsis:
      "民国时期，书香门第的千金与报馆记者在江南小城相识。动荡时局下，两人的感情被家族与战火一再考验。剧集以精美的服化道与克制的叙事，勾勒乱世中一段无法圆满的爱情。",
    releaseDate: "2022-06-18",
  },
  {
    id: "14",
    title: "我们的十年",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=youth%20coming%20of%20age%20drama%20poster%20artwork%2C%20group%20of%20friends%20on%20a%20university%20campus%20lawn%20at%20golden%20hour%2C%20bright%20warm%20yellow%20and%20sky%20blue%20tones%2C%20nostalgic%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=tv-05&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "北京",
    genre: "青春 / 成长",
    tags: ["青春", "成长", "友情"],
    director: "韩梅",
    cast: ["林书航", "苏念", "周晓"],
    rating: 8.3,
    popularity: 84,
    summary: "从大学到职场，四个好友用十年时间回答成长这道题。",
    synopsis:
      "四个大学室友在毕业后的十年里，各自经历事业的起伏与感情的变化。他们时而走散，时而又重新聚在一起。剧集以时间为轴，真实还原一代年轻人的理想、迷茫与坚持。",
    releaseDate: "2023-07-21",
  },
  {
    id: "15",
    title: "暗涌",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=gritty%20crime%20investigation%20drama%20poster%20artwork%2C%20detective%20studying%20a%20case%20board%20in%20a%20dim%20office%2C%20cold%20steel%20blue%20and%20dull%20orange%20accent%20tones%2C%20tense%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=tv-06&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "天津",
    genre: "悬疑 / 刑侦",
    tags: ["悬疑", "刑侦", "犯罪"],
    director: "郑立",
    cast: ["沈亦白", "张译川", "郑立川"],
    rating: 8.7,
    popularity: 93,
    summary: "平静水面之下暗流涌动，一桩旧案牵出盘根错节的利益网。",
    synopsis:
      "刑侦队长方岩重启一桩被搁置多年的悬案，随着调查深入，他发现自己面对的不仅是凶手，还有隐藏在城市表象之下的利益链条。剧集节奏紧凑、氛围压抑，是国产刑侦剧的诚意之作。",
    releaseDate: "2024-08-09",
  },
  {
    id: "16",
    title: "岁月如歌",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20family%20saga%20drama%20poster%20artwork%2C%20three%20generations%20of%20a%20family%20gathered%20around%20a%20dinner%20table%20under%20warm%20lamplight%2C%20cozy%20amber%20and%20soft%20brown%20tones%2C%20tender%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=tv-07&orientation=portrait",
    year: 2021,
    decade: "2020年代",
    region: "成都",
    genre: "家庭 / 情感",
    tags: ["家庭", "情感", "年代"],
    director: "林晚",
    cast: ["陈广生", "李知秋", "何一鸣"],
    rating: 8.2,
    popularity: 77,
    summary: "一个普通家庭的三十年，时代在变，团圆的饭桌始终没变。",
    synopsis:
      "剧集以成都一个普通家庭为切口，讲述三代人跨越三十年的悲欢离合。从工厂改制到子女远行，一家人在变化中守护着彼此。故事温情而不煽情，写尽中国家庭的烟火与羁绊。",
    releaseDate: "2021-12-24",
  },
  {
    id: "17",
    title: "星辰大海",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=space%20science%20fiction%20adventure%20drama%20poster%20artwork%2C%20astronaut%20floating%20before%20a%20vast%20glowing%20nebula%20and%20distant%20earth%2C%20deep%20indigo%20violet-blue%20and%20starlight%20tones%2C%20epic%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=tv-08&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "海南",
    genre: "科幻 / 冒险",
    tags: ["科幻", "冒险", "剧情"],
    director: "高远",
    cast: ["顾清和", "许安然", "沈亦白"],
    rating: 8.4,
    popularity: 88,
    summary: "一次深空任务，让两名航天员直面人类文明最深的孤独与希望。",
    synopsis:
      "深空探测船“远航号”在执行任务途中与地面失去联系，两名航天员必须在有限的资源下做出抉择。剧集融合硬核科幻设定与人文思考，在浩瀚星海间追问人类前行的意义。",
    releaseDate: "2023-10-27",
  },
  {
    id: "18",
    title: "向往的田野",
    type: "variety",
    poster:
      "https://readdy.ai/api/search-image?query=bright%20lifestyle%20reality%20show%20poster%20artwork%2C%20friends%20planting%20rice%20and%20laughing%20in%20a%20sunlit%20green%20terrace%20field%2C%20fresh%20green%20sky%20blue%20and%20warm%20orange%20tones%2C%20joyful%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=vr-01&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "云南",
    genre: "生活 / 真人秀",
    tags: ["真人秀", "生活", "治愈"],
    director: "田野工作室",
    cast: ["何一帆", "林书航", "苏念"],
    rating: 8.6,
    popularity: 92,
    summary: "一群嘉宾回到田野，用最朴素的方式种一季稻子、过一段慢生活。",
    synopsis:
      "节目邀请不同领域的嘉宾来到云南山村，从插秧、收割到做饭、赶集，用一整季的时间体验真实的田园生活。没有剧本，只有劳动、交流与治愈。四季更替间，观众看到的是久违的松弛与温暖。",
    releaseDate: "2024-04-12",
  },
  {
    id: "19",
    title: "声临其境之夜",
    type: "variety",
    poster:
      "https://readdy.ai/api/search-image?query=music%20competition%20reality%20show%20poster%20artwork%2C%20singer%20performing%20under%20a%20shower%20of%20stage%20spotlights%20and%20glowing%20notes%2C%20vivid%20magenta%20orange%20and%20deep%20blue%20tones%2C%20dynamic%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=vr-02&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "北京",
    genre: "音乐 / 竞演",
    tags: ["音乐", "竞演", "舞台"],
    director: "星声制作",
    cast: ["声临乐团", "林书航", "许安然"],
    rating: 8.5,
    popularity: 90,
    summary: "顶级歌手同台竞技，用声音重新演绎经典与原创。",
    synopsis:
      "节目汇集不同年代的歌手，通过改编、对唱与原创舞台展开比拼。每一期设置不同主题，从经典老歌到国风新作，用音乐讲述故事。舞台以顶级声光效果呈现，兼顾竞技性与音乐性。",
    releaseDate: "2024-01-05",
  },
  {
    id: "20",
    title: "全民挑战王",
    type: "variety",
    poster:
      "https://readdy.ai/api/search-image?query=fun%20game%20show%20poster%20artwork%2C%20contestants%20competing%20in%20a%20colorful%20obstacle%20arena%20with%20confetti%2C%20bright%20yellow%20orange%20and%20primary%20blue%20tones%2C%20playful%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=vr-03&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "上海",
    genre: "竞技 / 娱乐",
    tags: ["竞技", "娱乐", "综艺"],
    director: "挑战工作室",
    cast: ["何一帆", "周桐", "顾清和"],
    rating: 7.9,
    popularity: 80,
    summary: "素人与明星同场竞技，一场笑料百出的全民挑战。",
    synopsis:
      "节目设置脑力、体力与团队协作等多重关卡，素人选手与明星嘉宾同场较量。既有紧张刺激的竞技环节，也有轻松搞笑的临场反应。全民参与的形式让每一期都充满意外与欢乐。",
    releaseDate: "2023-03-24",
  },
  {
    id: "21",
    title: "厨房的秘密",
    type: "variety",
    poster:
      "https://readdy.ai/api/search-image?query=documentary%20food%20show%20poster%20artwork%2C%20chef%20flaming%20a%20wok%20in%20a%20steaming%20traditional%20kitchen%2C%20warm%20red%20amber%20and%20rich%20brown%20tones%2C%20appetizing%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=vr-04&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "四川",
    genre: "美食 / 纪实",
    tags: ["美食", "纪实", "人文"],
    director: "味觉影像",
    cast: ["陈广生", "林晚"],
    rating: 8.3,
    popularity: 79,
    summary: "走进街头巷尾的后厨，探寻一道道家常菜背后的秘密。",
    synopsis:
      "节目走访全国不同城市的老字号与小馆子，记录厨人们与食物相处的日常。从选料到出锅，每一道菜都承载着一方水土与人情。镜头关注味道，更关注味道背后的人。",
    releaseDate: "2023-05-19",
  },
  {
    id: "22",
    title: "一起露营吧",
    type: "variety",
    poster:
      "https://readdy.ai/api/search-image?query=healing%20outdoor%20camping%20reality%20show%20poster%20artwork%2C%20friends%20around%20a%20campfire%20by%20a%20lake%20under%20starry%20sky%20with%20tents%2C%20deep%20blue%20night%20and%20warm%20fire%20orange%20tones%2C%20serene%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=vr-05&orientation=portrait",
    year: 2024,
    decade: "2020年代",
    region: "浙江",
    genre: "户外 / 治愈",
    tags: ["户外", "治愈", "真人秀"],
    director: "野外日记",
    cast: ["何一帆", "林书航", "李知秋"],
    rating: 8.1,
    popularity: 83,
    summary: "远离城市，在湖边扎营，把生活过成一场山野的约会。",
    synopsis:
      "节目带嘉宾前往不同山川湖海，体验露营、徒步与野外烹饪。没有任务与竞争，只有自然、篝火与慢下来的对话。在星空与虫鸣之间，嘉宾也向观众分享了各自的生活感悟。",
    releaseDate: "2024-06-07",
  },
  {
    id: "23",
    title: "喜剧万花筒",
    type: "variety",
    poster:
      "https://readdy.ai/api/search-image?query=stand-up%20comedy%20show%20poster%20artwork%2C%20comedian%20with%20a%20microphone%20under%20a%20colorful%20spotlight%20and%20confetti%2C%20playful%20red%20yellow%20and%20violet%20tones%2C%20lively%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=vr-06&orientation=portrait",
    year: 2022,
    decade: "2020年代",
    region: "北京",
    genre: "喜剧 / 脱口秀",
    tags: ["喜剧", "脱口秀", "语言"],
    director: "笑果工场",
    cast: ["周桐", "何一鸣", "许安然"],
    rating: 7.7,
    popularity: 75,
    summary: "一群脱口秀演员，用五分钟讲透生活里的荒诞与温柔。",
    synopsis:
      "节目汇聚新老脱口秀演员，围绕职场、家庭、情感等话题展开表演。从冷场到爆梗，从自嘲到共鸣，每一期都藏着普通人生活的影子。笑声之外，也记录了一代年轻人的表达与态度。",
    releaseDate: "2022-11-11",
  },
  {
    id: "24",
    title: "旅行者的餐桌",
    type: "variety",
    poster:
      "https://readdy.ai/api/search-image?query=travel%20food%20documentary%20show%20poster%20artwork%2C%20traveller%20eating%20street%20food%20at%20a%20night%20market%20in%20an%20ancient%20town%2C%20warm%20lantern%20gold%20and%20teal%20tones%2C%20rich%20painterly%20background%2C%20no%20text%2C%20vertical%20composition&width=600&height=900&seq=vr-07&orientation=portrait",
    year: 2023,
    decade: "2020年代",
    region: "陕西",
    genre: "旅行 / 美食",
    tags: ["旅行", "美食", "纪实"],
    director: "味觉影像",
    cast: ["陈广生", "何一帆"],
    rating: 8.4,
    popularity: 81,
    summary: "跟着旅行者的脚步，用一张餐桌丈量一座座城市的味道。",
    synopsis:
      "主持人从古城夜市走到边陲小城，用一餐一饭认识一座城。节目将旅行与美食结合，记录市井烟火与地方风物，也讲述食物与人之间那些细水长流的故事。",
    releaseDate: "2023-08-25",
  },
];